export function buildFieldName(field) {
  return field.fieldName
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^\w-]+/g, '') + '_' + field.id;
}

export function textToHtml(text){
  const html = text
    .replace(/\n/g, '<br />');
  return html;
}